import React, { createContext, useContext } from 'react';

const SdkContext = createContext(null);

export const SdkProvider = ({ sdk, children }) => {
  return (
    <SdkContext.Provider value={sdk}>
      {children}
    </SdkContext.Provider>
  );
};

export const useSdk = () => {
  const sdk = useContext(SdkContext);

  if (!sdk) {
    throw new Error('useSdk musi być użyty wewnątrz SdkProvidera!');
  }

  return sdk;
};